import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole } from '@sentry/integrations'
import { SENTRY_DSN } from '../constants/sentry'

Sentry.init({
  dsn: process.env.NODE_ENV === 'development' || window.location.href.includes('sandbox') ? '' : SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing(),
    new CaptureConsole({
      levels: ['warn', 'error']
    })
  ],
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV
})

export default Sentry